/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const generateWelcomeScreenRequestDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	organisationId: z.string().uuid(),
	campaignId: z.string().uuid(),
	jobTitle: z.string(),
	jobLocation: z.string(),
	jobDescription: z.string(),
	toneOfVoice: z.string(),
	language: z.string(),
	targetAudience: z.string().nullable().optional(),
	additionalInstructions: z.string().nullable().optional(),
})

export type GenerateWelcomeScreenRequestDataSchema = z.infer<typeof generateWelcomeScreenRequestDataSchema>
